import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Loading from '../../shared/Loading';
import EirCustomiseBundleIncludes from '../EirCustomiseBundleIncludes';
import EirCustomiseBroadbandUpgrade from './EirCustomiseBroadbandUpgrade';
import EirCustomiseBroadbandOfferDetailTile from './EirCustomiseBroadbandOfferDetailTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import EirCustomisePageCartDock from '../EirCustomisePageCartDock';
import {Hidden} from '@material-ui/core'
import {css} from 'emotion'

function EirCustomiseBundleBroadband(props) {
    const getOrderDetails = JSON.parse(localStorage.getItem("eir_prequal_order"));
    // const [renderContent, setRenderContent] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [displayUpgrade, setDisplayUpgrade] = useState(true);

    //const [bb_price, setbb_price] = useState();
    const bundleDetails = JSON.parse(localStorage.getItem("bundleDetails"));
    var price_bb,after_price,after_months;
    var display_upgrade = true;
    const be_eir_prequal_result = JSON.parse(localStorage.getItem("eir_prequal_result"));
    
    if(be_eir_prequal_result.alternativeBundle.length>0){
        price_bb = parseFloat(be_eir_prequal_result.alternativeBundle[0].promoPrice).toFixed(2); 
        
        if(be_eir_prequal_result.alternativeBundle[0].priceBreakdown[1]){
        after_price = parseFloat(be_eir_prequal_result.alternativeBundle[0].priceBreakdown[1].price).toFixed(2);
        after_months =  be_eir_prequal_result.alternativeBundle[0].priceBreakdown[1].startMonth;
        }

        if(be_eir_prequal_result.alternativeBundle[0].voice.plan.name.toLowerCase().includes('talk mobile world')){
            display_upgrade=false;
        }
    }
    else if(be_eir_prequal_result.requestedBundle == null || !(be_eir_prequal_result.requestedBundleOK)){
        for(var i=0;i<be_eir_prequal_result.recommendedBundles.length;i++){
            if(be_eir_prequal_result.recommendedBundles[i].bundleCode == localStorage.getItem("eir_clicked_bundle_code_from_prequal")){           
               
                price_bb = parseFloat(be_eir_prequal_result.recommendedBundles[i].promoPrice).toFixed(2); 
                
                if(be_eir_prequal_result.recommendedBundles[i].priceBreakdown[1])
                {
                after_price = parseFloat(be_eir_prequal_result.recommendedBundles[i].priceBreakdown[1].price).toFixed(2);
                after_months =  be_eir_prequal_result.recommendedBundles[i].priceBreakdown[1].startMonth;
                }
                if(be_eir_prequal_result.recommendedBundles[i].voice.plan.name.toLowerCase().includes('talk mobile world')){
                    display_upgrade=false;
                }
            }
        }
    }
    else{
        price_bb = parseFloat(be_eir_prequal_result.requestedBundle.promoPrice).toFixed(2); 
        if(be_eir_prequal_result.requestedBundle.priceBreakdown[1]){
        after_price = parseFloat(be_eir_prequal_result.requestedBundle.priceBreakdown[1].price).toFixed(2);
        after_months =  be_eir_prequal_result.requestedBundle.priceBreakdown[1].startMonth;
        }
        if(be_eir_prequal_result.requestedBundle.voice.plan.name.toLowerCase().includes('talk mobile world')){
            display_upgrade=false;
        }
    }
    const bb_price=price_bb;
    const bb_after_price = after_price; const bb_after_months = after_months; 
    
    const [upgradeLLDefaultButtonId, setUpgradeLLDefaultButtonId] = useState($(".hide-default-item"));
    const [priceDtlsFromLS, setPriceDtlsFromLS] = useState(JSON.parse(localStorage.getItem("eir_prequal_order")));
    let bbTilePriceDetails = $(".pricePanelTextBB").html();
    const printPriceDetails = () => {
        var priceDetailsCtr = document.querySelector(".broadband-config .config-card__card.selected .bb-tile-price-dtl");
        // document.querySelector(".pricePanelTextBB").clasList.add("d-none");
        setPriceDtlsFromLS(JSON.parse(localStorage.getItem("eir_prequal_order")));
        //console.log("priceDtlsFromLS >>>>>>>>>>>>>>>> ", priceDtlsFromLS);
        // var printCopyForPriceDetails = '<p class="price-detail-onload"><span class="formatted-price"> ' + priceDtlsFromLS.formattedPromoMonthlyCost + '</span><span class="pricePanelTextBB"> a month for 24 months</span> <span class="formatted-total">&euro;' + priceDtlsFromLS.formattedTotal + ' after 24 months </span></p>'
        // var printCopyForPriceDetails = '<p class="price-detail-onload"><span class="formatted-price"> &euro;' + priceDtlsFromLS.formattedPromoMonthlyCost + '</span><span class="pricePanelTextBB"> a month for 24 months</span> <span class="formatted-total">&euro;' + priceDtlsFromLS.formattedTotal + ' after 24 months </span></p>'
        var printCopyForPriceDetails = '<p class="price-detail-onload"><span class="pricePanelTextBB"> a month for 24 months</span> <span class="formatted-total">&euro;' + priceDtlsFromLS.formattedTotal + ' after 24 months </span></p>'
        priceDetailsCtr.innerHTML = printCopyForPriceDetails;
    }

    useEffect(() => {
        // $(".stepper-buttons").addClass("d-none");
        // $(".customise-cart-dock").addClass("d-none");
        setTimeout(() => {
            // setIsLoading(false);
            setDisplayUpgrade(display_upgrade);
            if(display_upgrade){
            /****************************** UPGRADE TILE  - hide the default that is part of bundle****************************************************/
            let upgradePhoneCtr = document.querySelector(".homephone-config");
            let upgradeItems = upgradePhoneCtr.querySelectorAll(".config-card__card");
            for (var i = 0; i < upgradeItems.length; i++) {
                if (
                    upgradeItems[i].getAttribute('data-key') == 'RT_VOBB_A_TALK_OFFPEAK_2023' ||
                    upgradeItems[i].getAttribute('data-key') == 'RT_FIXED_A_TALK_OFFPEAK_2023'
                ) {
                    upgradeItems[i].classList.add('hide-default-item');
                    // setUpgradeLLDefaultButtonId(upgradeItems[i].querySelector(".upgrade-phone-cta").querySelector(".config-card__button").getAttribute("id"));
                }
            }
            /****************************** BB TILE  - convert the bundle copy into a list **********************************************************/
            }
            document.querySelector(".bb-stepper-content").classList.remove("d-none");            
            //console.log("bbTilePriceDetails >>>>>>>>> ", bbTilePriceDetails);
            setIsLoading(false);
            config.summary.update(); 
           // console.log("summay.update >>>")
            config.basket.update(); 
            //console.log("basket.update >>>")
            config.event.update.trigger(document);   
            config.broadband.init();        
            //$(".pricePanelTextBB").html(bbTilePriceDetails).removeClass("d-none");
            //$(".pricePanelTextBB").removeClass("d-none");
            (isMobileOnly && $('#upgrade-phone-img-1').attr("src",'/.galleries/customise-page/bbspeed-tile-image.png'));
                        
        }, 9500);
    }, [bbTilePriceDetails]);   

    $(".homephone-config .config-card__button").on("click", function (e) {
        //console.log("button clicked");
        $(this).addClass("clicked-bg");
        var getBBTilePiceDetails = document.querySelector(".bbtile-price-breakdown");
        var priceDetailsCtr = document.querySelector(".broadband-config .config-card__card.selected .bb-tile-price-dtl");
        var loadingDiv = '<div class="spinner__wrapper selected-loader" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"> <div class="spinner--animation ap-fade-in white"> <div class="spinner--block rotateG_01"></div><div class="spinner--block rotateG_02"></div><div class="spinner--block rotateG_03"></div></div></div></div>'
        if ($(this).closest("div.config-card__card").hasClass("selected") && !$(this).hasClass("hide-default-item")) {
           // console.log("inside click button >>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            e.preventDefault();
            //console.log("after prev def");
            document.querySelector(".hide-default-item .config-card__button").click();
            $(this).append(loadingDiv);
            setTimeout(() => {
                $(this).removeClass("clicked-bg");
            }, 1800);
            return false;
            //hide the element that displayed price onload - from  printPriceDetails function
        } else {
            //console.log("default clicked -----------------------");
        }
        priceDetailsCtr.classList.add("d-none");
        getBBTilePiceDetails.classList.remove("d-none");
    })


// Overlapping Text Fix
    const cssStyles = {
        broadbandConfig: {
            root: css`width: 588px !important;`,
            configCard: css`
                & .config-card__inner{
                    @media (max-width: 600px){
                       
                    }
                }
            `,
            bbPriceHolder: css`width: 52% !important; position: relative !important; float: right !important; `,
            bbTilePriceDetails: css`margin: 0 !important; width: 100% !important; bottom: calc(100% + 12px) !important`,
            pricePanelTextBB: css`position: relative !important; bottom:0 !important; width: 100% !important`,
            monthlyTotalPrice: css`
                margin: 0 !important;
                float: left !important;`, 
        },
        bbTilePriceDetails: { 
            root: css`
                position: absolute !important;
                top: auto !important;
                bottom: 6px;
                width: 100% !important;
            `,
            monthlyTotalPrice: css`
                margin: 0 !important;
                float: left !important;`, 
            pricePanelTextBB: css`position: relative !important; bottom: 3px !important; width: 100% !important`
        },
    }

    return (
        <div>
           
            {isLoading &&
                <Loading className="m-5" />
            }
            <div className="bb-stepper-content d-none">                

                {/* {(renderContent) && */}
                <div>
                    {/* -------------------------------------------------- Prequal details start     -------------------------------------------------- start */}
                    <p className="prequalDetail d-flex justify-content-center align-items-center mb0 mt2"></p>
                    <p className="speedTest d-flex justify-content-center align-items-center mb-2"></p>
                    <p className="startAgainLink"></p>
                    {/* -------------------------------------------------- Prequal details end     -------------------------------------------------- start */}

                    {/* -------------------------------------------------- Broadband and offer details -------------------------------------------------- start */}

                    <Row className="d-flex justify-content-center align-items-center bb-step-parent">
                        <div className=" d-none"><p className="bundle-summary__subtext"></p></div>
                        <div className="broadband-details-ctr">
                            <div className="broadband-config" style={isMobileOnly?{}:{width:'588px'}}>
                                <div className={`config-card ${cssStyles.broadbandConfig.configCard}`}>
                                </div>
                                <Hidden xsDown>
                                    <div className={`bb-price-holder ${cssStyles.broadbandConfig.bbPriceHolder}`} >
                                        <div className={`bb-tile-price-details ${cssStyles.broadbandConfig.bbTilePriceDetails}`} >
                                            <p className={`bb__price ${cssStyles.broadbandConfig.monthlyTotalPrice}`}>&euro;{bb_price}<span className='bb_a_month'> a month</span></p>
                                            {/* <p className={`bb__price application-page__sidebar__pay-monthly__total__price ${cssStyles.broadbandConfig.monthlyTotaPrice}`}></p> */}
                                            <div className="application-page__sidebar__pay-monthly__discounts__info__text__container bbtile-price-breakdown">
                                                <p className={`application-page__sidebar__pay-monthly__discounts__info__text_bb pricePanelTextBB ${cssStyles.broadbandConfig.pricePanelTextBB}`}>
                                                {bb_after_price &&
                                                <span class="">&euro;{bb_after_price} after {bb_after_months} months </span>
                                                }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Hidden>
                            </div>
                            <Hidden smUp>
                                <div className={`bb-tile-price-details ${cssStyles.bbTilePriceDetails.root}`} >
                                    <p className={`bb__price ${cssStyles.bbTilePriceDetails.monthlyTotalPrice}`}>&euro;{bb_price}<span className='bb_a_month'> a month</span></p>
                                    {/* <p className={`bb__price application-page__sidebar__pay-monthly__total__price ${cssStyles.bbTilePriceDetails.monthlyTotaPrice}`}></p> */}
                                    <div className="application-page__sidebar__pay-monthly__discounts__info__text__container bbtile-price-breakdown">
                                        <p className={`application-page__sidebar__pay-monthly__discounts__info__text_bb pricePanelTextBB ${cssStyles.bbTilePriceDetails.pricePanelTextBB}`}>
                                        {bb_after_price &&
                                        <span class="">&euro;{bb_after_price} after {bb_after_months} months </span>
                                        }
                                        </p>
                                    </div>
                                </div>
                            </Hidden>
                        </div>
                        {/* The details of the product ---- end */}

                        {/* BUNDLE OFFERS START*/}                        
                        <EirCustomiseBroadbandOfferDetailTile />
                    </Row>
                    {/* BUNDLE OFFERS END*/}

                    {/* -------------------------------------------------- Broadband and offer details -------------------------------------------------- end */}


                    {/* -------------------------------------------------- Upgrade your landline / Phone ---------------------------------------------- start */}
                    {/* ---- the script will be printing the phone details in the below div */}

                    {displayUpgrade &&
                    <EirCustomiseBroadbandUpgrade />
                    }
                    {/* -------------------------------------------------- Upgrade your landline / Phone ------------------------------------------------- end */}

                    <div className="d-none">Existing Customer</div>

                    <div className="ap-config__accordion__bellow broadband-config d-none">
                        <div className="ap-config__accordion__bellow__upsell show">
                            <h3 className="ap-config__accordion__bellow__upsell__heading">
                                Why not add...
                </h3>
                            <div className="ap-config__accordion__bellow__upsell__title icon-combo icon-combo--inline icon-combo--25h-25w">
                                <div className="icon-broadband_grey-dark icon-combo__icon"></div>
                                <div className="inline text-bottom">Broadband</div>
                            </div>
                            <p className="ap-config__accordion__bellow__upsell__description">
                                Depending on availability in your area, you may be able to tailor your broadband plan to suit you.
                </p>
                            <p className="ap-config__accordion__bellow__upsell__button">
                                <a href="" className="button button--secondary fill-pink add-broadband gtm-normal-cta">Add Broadband</a>
                            </p>
                        </div>
                        <div className="ap-config__accordion__bellow__header">
                            <div className="ap-config__accordion__bellow__header__title icon-combo icon-combo--inline icon-combo--25h-25w">
                                <div className="icon-broadband_grey-dark icon-combo__icon"></div>
                                <div className="inline text-bottom">Broadband</div>
                            </div>
                            <div className="ap-config__accordion__bellow__header__text">
                                <p className="ap-config__accordion__bellow__header__description">Check here to see if faster speeds are available in your area.</p>                                
                                <p className="ap-config__accordion__bellow__header__error">This product cannot be removed from your order as it is an integral part of the bundle you selected.</p>
                            </div>
                            <div className="ap-config__accordion__bellow__header__button">
                                <div className="ap-config__accordion__bellow__header__button__tooltip" data-tooltip="true" data-tooltip-type="generic-manual" data-tooltip-body="View more"></div>
                            </div>
                        </div>
                        <div className="ap-config__accordion__bellow__body">
                            {/* <div className="row">
                                <div className="column large-12 small-12">
                                    <div className="alert fill-blue">
                                        <div className="row">
                                            <div className="alert__text-column">
                                                <p className="alert__header">We Need Your Attention!</p>
                                                <p className="alert__subtext">You may have made some changes to your original bundle. If you would like to revert click the button.</p>
                                            </div>
                                            <div className="alert__button-column">
                                                <a href="" className="button button--small button--secondary fill-white text-black--light gtm-normal-cta">Update Cart</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="config-card">
                                <div className="config-card__card config-card__card--size-6 selected config-card-heading config-card-subtext config-card-price config-card-button">
                                    <div className="config-card__inner">
                                        <div className="config-card__promo">
                                            <p className="config-card__promo__heading">
                                                {/* <%--Save 20% on your first 3 months!--%> */}
                                            </p>
                                        </div>
                                        <div className="config-card__disabled">
                                            <p className="config-card__disabled__heading">Incompatible with chosen bundle!</p>
                                        </div>
                                        <div className="config-card__base">
                                            <p className="config-card__heading">
                                                {/* <%--Unlimited Broadband--%> */}
                                            </p>
                                            <p className="config-card__subtext">
                                                {/* <%--Unlimited Usage Allowance--%> */}
                                            </p>
                                            <div className="config-card__price euro per-month">
                                                {/* <%--<p className="config-card__price__strike"><strike></strike></p>5--%> */}
                                            </div>
                                            <a href="" className="config-card__link gtm-linkclick-cta">View Channels</a>
                                            <a className="config-card__button select"></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="config-card__card config-card__card--size-6 config-card-heading config-card-subtext config-card-price config-card-button">
                                    <div className="config-card__inner">
                                        <div className="config-card__promo">
                                            <p className="config-card__promo__heading">
                                                {/* <%--Save 20% on your first 3 months!--%> */}
                                            </p>
                                        </div>
                                        <div className="config-card__disabled">
                                            <p className="config-card__disabled__heading">Incompatible with chosen bundle!</p>
                                        </div>
                                        <div className="config-card__base">
                                            <p className="config-card__heading">
                                                {/* <%--Option 2--%> */}
                                            </p>
                                            <p className="config-card__subtext">
                                                {/* <%--This is a flexbox container where rows have matching heights--%> */}
                                            </p>
                                            <div className="config-card__price euro per-month">
                                                {/* <%--<p className="config-card__price__strike"><strike></strike></p>5--%> */}
                                            </div>
                                            <a href="" className="config-card__link gtm-linkclick-cta">View Channels</a>
                                            <a className="config-card__button select"></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="config-card__card config-card__card--size-6 config-card-heading config-card-subtext config-card-price config-card-button">
                                    <div className="config-card__inner">
                                        <div className="config-card__promo">
                                            <p className="config-card__promo__heading">
                                                {/* <%--Save 20% on your first 3 months!--%> */}
                                            </p>
                                        </div>
                                        <div className="config-card__disabled">
                                            <p className="config-card__disabled__heading">
                                                Incompatible with chosen bundle!
                                </p>
                                        </div>
                                        <div className="config-card__base">
                                            <p className="config-card__heading">
                                                {/* <%--Option 3--%> */}
                                            </p>
                                            <p className="config-card__subtext">
                                                {/* <%--Unlimited Usage Allowance--%> */}
                                            </p>
                                            <div className="config-card__price euro per-month">
                                                {/* <%--<p className="config-card__price__strike"><strike></strike></p>5--%> */}
                                            </div>
                                            <a href="" className="config-card__link gtm-linkclick-cta">View Channels</a>
                                            <a className="config-card__button select"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ap-config__accordion__bellow__border"></div>
                    </div>
                </div >
                {/* } */}
            </div >           
        </div >

    );
}
export default EirCustomiseBundleBroadband;
